var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoF7A823(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 47,
    viewBox: "0 0 78 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_7654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.81 36.383C77.81 41.4442 71.8419 46.9942 66.9894 46.9942H0V10.6112C0 5.66629 4.84062 0 10.8265 0H77.81V36.383Z",
    fill: "#F7A823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34949 27.3369H20.7793V28.8262H9.19129V33.1545H20.3365V34.6438H9.19129V39.356H20.8442V40.8453H7.34949V27.3369Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5479 27.3369H26.4404L34.4274 38.6346L42.4204 27.3369H45.307V40.8162H43.4593V28.9716H43.418L35.0945 40.8162H33.7722L25.4428 28.9716H25.4074V40.8162H23.5538L23.5479 27.3369Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7132 27.3369H51.6234L59.6163 38.6346L67.562 27.3369H70.4546V40.8162H68.601V28.9716H68.5656L60.2362 40.8162H58.9139L50.5845 28.9716H50.5431V40.8162H48.6954L48.7132 27.3369Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_211_7654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.81,
    height: 47,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoF7A823);
export default __webpack_public_path__ + "static/media/logo_f7a823.df1ffcca25e24937625b97fb0c886f3c.svg";
export { ForwardRef as ReactComponent };